import { useSyncExternalStore } from 'react'
import {
  generatorHistoryStore,
  type GeneratorHistoryEntry,
} from '../services/generatorHistoryStore'

/** GeneratorPage の履歴 UI 用フック (subscribe で再描画 + アクションを返す)。 */
export interface UseGeneratorHistory {
  entries: readonly GeneratorHistoryEntry[]
  remove: (id: string) => void
  clear: () => void
}

export const useGeneratorHistory = (): UseGeneratorHistory => {
  const entries = useSyncExternalStore(
    generatorHistoryStore.subscribe,
    generatorHistoryStore.getEntries,
    generatorHistoryStore.getEntries,
  )

  return {
    entries,
    remove: generatorHistoryStore.remove,
    clear: generatorHistoryStore.clear,
  }
}
